import Admin from "./img/Admin.svg";
import Call from "./img/Call_Phone_Mobile.svg";
import FaceMatch from "./img/Codes_Scan.svg";
import Dashboard from "./img/Dashboard.svg";
import Reports from "./img/file_remarks_description_report.svg";
import Ekyc from "./img/ID_Card_Verify.svg";
import Route from "./img/route_path_direction.svg";
import Outlet from "./img/store_outlet_shop.svg";
import Leaderboard from "./img/trophy_leaderboard_crest.svg";
import Upload from "./img/upload_share.svg";
import User from "./img/User_Group_People.svg";
import UserProfile from "./img/user_account.svg";
import MapPin from "./img/map_pin.svg";
import BarChartIcon from "./img/bar_chart.svg";
import SettingsIcon from "./img/settings_gear.svg";
import CorporateFareIcon from "./img/corporate_fare_sponsor.svg";

import AdminSelected from "./img/Admin_Selected.svg";
import CallSelected from "./img/Call_Phone_Mobile_Selected.svg";
import FaceMatchSelected from "./img/Codes_Scan_Selected.svg";
import DashboardSelected from "./img/Dashboard_Selected.svg";
import ReportsSelected from "./img/file_remarks_description_report_Selected.svg";
import EkycSelected from "./img/ID_Card_Verify_Selected.svg";
import RouteSelected from "./img/route_path_direction_Selected.svg";
import OutletSelected from "./img/store_outlet_shop_Selected.svg";
import LeaderboardSelected from "./img/trophy_leaderboard_crest_Selected.svg";
import UploadSelected from "./img/upload_share_Selected.svg";
import UserSelected from "./img/User_Group_People_Selected.svg";
import UserProfileSelected from "./img/user_account_Selected.svg";
import MapPinSelected from "./img/map_pin_selected.svg";
import BarChartIconSelected from "./img/bar_chart_selected.svg";
import SettingsIconSelected from "./img/settings_gear_selected.svg";
import CorporateFareIconSelected from "./img/corporate_fare_sponsor_selected.svg";
import {
  APP_SCOPE_MERCHANT_BUSINESS,
  APP_SCOPE_ONLINE,
  MANAGER_TYPES,
  USER_TYPES,
} from "../UserList/utils/userConfigs";

const NavLinkList = [
  {
    icon: Dashboard,
    iconSelected: DashboardSelected,
    name: "Dashboard",
    to: "/dashboard",
    scopes: [APP_SCOPE_ONLINE, APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
  {
    icon: Reports,
    iconSelected: ReportsSelected,
    name: "Reports",
    to: "/new-reports",
    scopes: [APP_SCOPE_ONLINE, APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.WAREHOUSE_MANAGER,
      USER_TYPES.CS_SUPER_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
  },
  {
    icon: Dashboard,
    iconSelected: DashboardSelected,
    name: "Service Referral",
    to: "/service-referral",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
  },
  {
    icon: Call,
    iconSelected: CallSelected,
    name: "Calls",
    to: "/calls",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
  },
  {
    icon: User,
    iconSelected: UserSelected,
    name: "People",
    to: "/field-force",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
  {
    icon: Outlet,
    iconSelected: OutletSelected,
    name: "Outlets",
    to: "/outlets",
    scopes: [APP_SCOPE_ONLINE, APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
  },
  {
    icon: Upload,
    iconSelected: UploadSelected,
    name: "Upload",
    to: "/new-uploads",
    scopes: [APP_SCOPE_ONLINE, APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
    ],
  },

  {
    icon: Ekyc,
    iconSelected: EkycSelected,
    name: "e-KYC",
    to: "/ekyc",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
  },
  {
    icon: Reports,
    iconSelected: ReportsSelected,
    name: "Inventory",
    to: "/inventory-management",
    scopes: [APP_SCOPE_ONLINE, APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.WAREHOUSE_MANAGER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
  {
    icon: Admin,
    iconSelected: AdminSelected,
    name: "Admin",
    to: "/admin",
    scopes: [APP_SCOPE_ONLINE, APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
  {
    icon: MapPin,
    iconSelected: MapPinSelected,
    name: "Geo Management",
    to: "/geo-management",
    scopes: [APP_SCOPE_ONLINE, APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
  },
  {
    icon: User,
    iconSelected: UserSelected,
    name: "User Management",
    to:
      JSON.parse(localStorage.getItem("currUserType")) ===
      USER_TYPES.AGENCY_USER
        ? "/my-profile"
        : "/users",
    submenu: [
      {
        name: "User List",
        icon: Reports,
        iconSelected: ReportsSelected,
        to: "/users",
        scopes: [APP_SCOPE_MERCHANT_BUSINESS],
        userTypes: [
          USER_TYPES.BKASH_SUPER_USER,
          USER_TYPES.CS_SUPER_USER,
          USER_TYPES.AREA_MANAGER,
          USER_TYPES.REGIONAL_MANAGER,
          USER_TYPES.TERRITORY_MANAGER,
          USER_TYPES.CIRCLE_HEAD,
        ],
        managerTypes: [
          MANAGER_TYPES.MDE,
          MANAGER_TYPES.MDM,
          MANAGER_TYPES.MAM,
          MANAGER_TYPES.MMM,
        ],
      },
      {
        name: "My Profile",
        icon: UserProfile,
        iconSelected: UserProfileSelected,
        to: "/my-profile",
        scopes: [APP_SCOPE_MERCHANT_BUSINESS],
        userTypes: [
          USER_TYPES.BKASH_SUPER_USER,
          USER_TYPES.CS_SUPER_USER,
          USER_TYPES.AREA_MANAGER,
          USER_TYPES.REGIONAL_MANAGER,
          USER_TYPES.TERRITORY_MANAGER,
          USER_TYPES.CIRCLE_HEAD,
          USER_TYPES.AGENCY_USER,
          USER_TYPES.WAREHOUSE_MANAGER,
        ],
        managerTypes: [
          MANAGER_TYPES.MDE,
          MANAGER_TYPES.MDM,
          MANAGER_TYPES.MAM,
          MANAGER_TYPES.MMM,
          MANAGER_TYPES.DISTRIBUTOR,
          MANAGER_TYPES.OPERATION_MANAGER,
        ],
      },
    ],
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CS_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.WAREHOUSE_MANAGER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
  {
    icon: CorporateFareIcon,
    iconSelected: CorporateFareIconSelected,
    name: "KPI Tracking",
    to: "/kpi-leaderboard",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    submenu: [
      {
        icon: BarChartIcon,
        iconSelected: BarChartIconSelected,
        name: "Leaderboard",
        to: "/kpi-leaderboard",
        scopes: [APP_SCOPE_MERCHANT_BUSINESS],
        userTypes: [
          USER_TYPES.BKASH_SUPER_USER,
          USER_TYPES.CIRCLE_HEAD,
          USER_TYPES.AREA_MANAGER,
          USER_TYPES.REGIONAL_MANAGER,
          USER_TYPES.TERRITORY_MANAGER,
          USER_TYPES.AGENCY_USER,
        ],
        managerTypes: [
          MANAGER_TYPES.MDE,
          MANAGER_TYPES.MDM,
          MANAGER_TYPES.MAM,
          MANAGER_TYPES.MMM,
          MANAGER_TYPES.DISTRIBUTOR,
          MANAGER_TYPES.OPERATION_MANAGER,
        ],
      },
      {
        icon: SettingsIcon,
        iconSelected: SettingsIconSelected,
        name: "Configuration",
        to: "/kpi-metric-configuration",
        scopes: [APP_SCOPE_MERCHANT_BUSINESS],
        userTypes: [USER_TYPES.BKASH_SUPER_USER],
      },
    ],
  },
  {
    icon: Leaderboard,
    iconSelected: LeaderboardSelected,
    name: "Leaderboard",
    to: "/leaderboard",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [USER_TYPES.BKASH_SUPER_USER, USER_TYPES.TERRITORY_MANAGER],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
    ],
  },
  {
    icon: Route,
    iconSelected: RouteSelected,
    name: "Routes",
    to: "/route-management",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
  {
    icon: Ekyc,
    iconSelected: EkycSelected,
    name: "Bank Inclusion",
    to: "/bank-inclusion-requests",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      // USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CS_SUPER_USER,
      USER_TYPES.CS_USER_LAYER_1,
      USER_TYPES.CS_USER_LAYER_2,
    ],
  },
  {
    icon: Ekyc,
    iconSelected: EkycSelected,
    name: "Loan Requests",
    to: "/merchant-loan-requests",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
  },
  {
    icon: FaceMatch,
    iconSelected: FaceMatchSelected,
    name: "Face matching",
    to: "/face-matching",
    scopes: [APP_SCOPE_MERCHANT_BUSINESS],
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.CIRCLE_HEAD,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
];

export { NavLinkList };
